module.exports = require("@angular/forms");


//////////////////
// WEBPACK FOOTER
// external "@angular/forms"
// module id = 26
// module chunks = 0